const demoResultPresets = {
    innovator: {
        id: 'innovator',
        hero: {
            eyebrow: 'Demo',
            title: 'Yancha Career Compass Demo',
            subtitle: 'Demo Crystam Report',
            summary: 'This demo preview highlights how Yancha can identify interests, behavior, and decision tendencies. For full report get in touch'
        },
        riasec: {
            title: 'Your Personality Scorecard (RIASEC)',
            subtitle: 'Vocation as Expression',
            description: 'Your profession can become a direct expression of your personality. Stronger scores often indicate environments where you may feel more energized, effective, and fulfilled.',
            labels: [
                { code: 'R', title: 'Realistic', subtitle: 'Doers' },
                { code: 'I', title: 'Investigative', subtitle: 'Thinkers' },
                { code: 'A', title: 'Artistic', subtitle: 'Creators' },
                { code: 'S', title: 'Social', subtitle: 'Helpers' },
                { code: 'E', title: 'Enterprising', subtitle: 'Persuaders' },
                { code: 'C', title: 'Conventional', subtitle: 'Organizers' }
            ],
            values: { R: 6, I: 9, A: 4, S: 6, E: 3, C: 2 }
        },
        archetype: {
            banner: 'Archetype Spotlight',
            name: 'The Innovator',
            identity: 'An analytical builder of what comes next.',
            strengthTitle: 'Key Strength',
            strengthText: 'You excel at processing new information, spotting patterns, and imagining sharper future-facing solutions.',
            formula: 'Profile Formula: Curious investigation + positive attitude + calculated decision making = an innovative problem-solver.',
            bullets: [
                'Drawn to solving real-world problems through logic and invention',
                'Learns quickly when challenged by complexity or novelty',
                'Often shines in roles that combine systems thinking and initiative'
            ]
        },
        compass: {
            title: 'The 4-Pillar RAPiD Behavioral Compass',
            pillars: [
                {
                    code: 'A',
                    title: 'Attitude',
                    description: 'Approach to life and setbacks with a generally constructive, forward-moving outlook.',
                    accent: 'from-orange-400 to-orange-500'
                },
                {
                    code: 'R',
                    title: 'Resources',
                    description: 'Ability to notice, access, and use the right tools, people, and systems without overdependence.',
                    accent: 'from-emerald-400 to-teal-500'
                },
                {
                    code: 'P',
                    title: 'Perspectives',
                    description: 'Tendency to interpret situations independently while remaining open to better viewpoints.',
                    accent: 'from-amber-400 to-yellow-500'
                },
                {
                    code: 'D',
                    title: 'Decision Making',
                    description: 'A style that balances logic, prudence, and timing before action.',
                    accent: 'from-purple-400 to-fuchsia-500'
                }
            ]
        },
        careerMatrix: {
            title: 'The 3x3 Career Constellation Matrix',
            columns: ['Rational', 'Calculated', 'Emotional'],
            rows: [
                {
                    title: 'Seek Out New',
                    cells: [
                        'Finance professionals, investigators, process designers, engineers',
                        'Entrepreneurs, product builders, growth leaders, sales strategists',
                        'Social innovators, design thinkers, experience creators, space storytellers'
                    ]
                },
                {
                    title: 'Others-Driven',
                    cells: [
                        'Public policy specialists, administrators, systems coordinators, legal operators',
                        'Consultants, journalists, civic leaders, operational communicators',
                        'Teachers, filmmakers, chefs, editors, authors'
                    ]
                },
                {
                    title: 'Self-Driven',
                    cells: [
                        'Scientists, architects, doctors, legal researchers, deep-tech builders',
                        'Bankers, defense professionals, crisis managers, field leaders',
                        'Agriculturists, sustainability founders, craft-led creators'
                    ]
                }
            ]
        }
    },
    strategist: {
        id: 'strategist',
        hero: {
            eyebrow: 'Demo',
            title: 'Your Yancha Strategic Career Compass',
            subtitle: 'A showcase archetype centered on judgment, structure, and long-range thinking.',
            summary: 'This variant demonstrates how a Yancha report can frame methodical strengths into a clear professional direction.'
        },
        riasec: {
            title: 'Your Personality Scorecard (RIASEC)',
            subtitle: 'Vocation as Expression',
            description: 'This sample profile reflects a person who likes systems, patterns, planning, and competent execution in complex environments.',
            labels: [
                { code: 'R', title: 'Realistic', subtitle: 'Doers' },
                { code: 'I', title: 'Investigative', subtitle: 'Thinkers' },
                { code: 'A', title: 'Artistic', subtitle: 'Creators' },
                { code: 'S', title: 'Social', subtitle: 'Helpers' },
                { code: 'E', title: 'Enterprising', subtitle: 'Persuaders' },
                { code: 'C', title: 'Conventional', subtitle: 'Organizers' }
            ],
            values: { R: 4, I: 8, A: 2, S: 5, E: 6, C: 8 }
        },
        archetype: {
            banner: 'Archetype Spotlight',
            name: 'The Strategist',
            identity: 'A calm planner who builds clarity before momentum.',
            strengthTitle: 'Key Strength',
            strengthText: 'You naturally organize complexity, compare options, and move projects forward with thoughtful precision.',
            formula: 'Profile Formula: Strong analysis + structured resources + deliberate decision making = a dependable strategic operator.',
            bullets: [
                'Thrives when structure, timing, and execution all matter',
                'Often trusted to reduce uncertainty and improve direction',
                'Fits environments that reward judgment more than noise'
            ]
        },
        compass: {
            title: 'The 4-Pillar RAPiD Behavioral Compass',
            pillars: [
                {
                    code: 'A',
                    title: 'Attitude',
                    description: 'Maintains composure under pressure and prefers practical optimism over reaction.',
                    accent: 'from-orange-400 to-orange-500'
                },
                {
                    code: 'R',
                    title: 'Resources',
                    description: 'Knows how to combine information, tools, and people into a usable plan.',
                    accent: 'from-emerald-400 to-teal-500'
                },
                {
                    code: 'P',
                    title: 'Perspectives',
                    description: 'Evaluates context from multiple angles before settling on direction.',
                    accent: 'from-amber-400 to-yellow-500'
                },
                {
                    code: 'D',
                    title: 'Decision Making',
                    description: 'Strong preference for calculated choices with visible trade-off awareness.',
                    accent: 'from-purple-400 to-fuchsia-500'
                }
            ]
        },
        careerMatrix: {
            title: 'The 3x3 Career Constellation Matrix',
            columns: ['Rational', 'Calculated', 'Emotional'],
            rows: [
                {
                    title: 'Seek Out New',
                    cells: [
                        'Policy researchers, analysts, financial planners, systems auditors',
                        'Business operators, program managers, product strategists, market planners',
                        'Brand storytellers, people strategists, mission-led founders'
                    ]
                },
                {
                    title: 'Others-Driven',
                    cells: [
                        'Institutional managers, coordinators, compliance leads, education planners',
                        'Consultants, newsroom planners, public affairs specialists, city managers',
                        'Learning designers, facilitators, culture builders, public communicators'
                    ]
                },
                {
                    title: 'Self-Driven',
                    cells: [
                        'Architects, scientists, legal thinkers, product researchers',
                        'Operations heads, defense officers, risk managers, execution leads',
                        'Independent creators, craft entrepreneurs, social practitioners'
                    ]
                }
            ]
        }
    }
};

export default demoResultPresets;
